import { useDataChange } from 'Simple/Data.js'

export default function useListItemDataOnChange(props) {
  let change = useDataChange({
    context: 'comms_settings',
    viewPath: props.viewPath,
  })

  return function onChange(flag) {
    change(next => {
      next.flags[props.index] = flag
    })
  }
}
